import moment from 'moment-timezone'
import { E_MAINTENANCE, E_NO_CONNECTION } from 'common/middleware/error'
import { notify } from './notify'

let defaults = require('superagent-defaults')

let superagent = defaults()

const methods = ['post']

let maintenanceMode = false

const replacer = (key, value) => (value === undefined ? null : value)

const stringify = (obj) => (JSON.stringify(obj, replacer))

const dateParser = (key, value) => {
    if (typeof value === 'string') {
        let a = moment(value, "YYYY-MM-DDTHH:mm:ss", true)
        if (a.isValid())
            return a.toDate();
    }
    return value;
}

const parse = (str) => (JSON.parse(str, dateParser))

function formatUrl(path) {
  const adjustedPath = path[0] !== '/' ? '/' + path : path;
  return '/api' + adjustedPath;
}

class ApiClient {
  constructor() {
    superagent
      .set('Content-Type', 'application/json')
      .set('Client-Build-Hash', __CLIENT_BUILD_HASH__)
      superagent.on('request', (req) => {
        console.log(`Request: ${req.url}`)
      })

    superagent.request.serialize['application/json'] = stringify
    superagent.request.parse = parse

    methods.forEach((method) =>
      this[method] = (path, { data } = {}) => {
        const request = superagent[method](formatUrl(path));
        data = data || {};
        console.log(data)
        request.send(data);

        const p = new Promise((resolve, reject) => {
          request.end((err, response) => {
            if (err) {
              if (err.status === 503) {
                maintenanceMode = true
                reject({
                  error: {
                    code: E_MAINTENANCE,
                    msg: "Our system is currently undergoing scheduled maintenance. Try again later."
                  }
                })
              }
              if (!response) {
                reject({
                  error: {
                    code: E_NO_CONNECTION,
                    msg: "No internet connection. Check your wireless and/or network settings and try again later."
                  }
                })
              }

              try {
                reject(parse(err.response.text))
              } catch (e) {
                reject({
                  error: {
                    code: -1,
                    msg: "An error occurred. Please try again later."
                  }
                })
              }
            } else {
              if (maintenanceMode) {
                notify.clear()
                maintenanceMode = false
              }

              resolve(response.body || parse(response.text))
            }
          })
        })
        p.request = request
        return p
      })
  }
}

export default new ApiClient()
